import { Button, Text, Columns, Column, csx } from '@vtex/admin-ui'
import React, { useMemo } from 'react'

import { SubmitProps } from './AttachmentForm'
import { FormattedMessage } from 'react-intl'
import { transformFormsValuesMap } from './utils'
import { Attachment } from '@/checkout-instore-legacy/product/typings'

interface AttachmentSummaryProps {
  attachments: Attachment[]
  formsValues: Map<number, SubmitProps>
  onEdit: (step: number) => void
  onSubmit: () => void
}

export const AttachmentSummary = ({
  attachments,
  formsValues,
  onEdit,
  onSubmit,
}: AttachmentSummaryProps) => {
  const formsValuesMap = useMemo(() => transformFormsValuesMap(formsValues), [
    formsValues,
  ])

  if (!attachments) {
    return null
  }

  return (
    <div className={csx({ marginY: '$space-4', paddingX: '$space-6' })}>
      {attachments.map((attachment) => {
        return (
          <div
            key={attachment.id}
            className={csx({ paddingBottom: '$space-2' })}
          >
            <Columns>
              <Column units={10} className={csx({ display: 'flex' })}>
                <Text
                  variant="detail"
                  tone="secondary"
                  className={csx({ alignSelf: 'center' })}
                >
                  {attachment.name}
                </Text>
              </Column>
              <Column
                units={2}
                className={csx({ display: 'flex', flexDirection: 'column' })}
              >
                <Button
                  variant="tertiary"
                  onClick={() => onEdit(formsValuesMap[attachment.id].step)}
                  className={csx({ alignSelf: 'end' })}
                >
                  <FormattedMessage id="attachments.modal.summary.edit-values" />
                </Button>
              </Column>
            </Columns>

            {Object.entries(
              formsValuesMap[attachment.id].formValues.content
            ).map(([label, inputValue], index) => {
              return (
                <div
                  key={`${label}-${index}`}
                  className={csx({ paddingBottom: '$space-2' })}
                >
                  <Text variant="action2" className={csx({ display: 'block' })}>
                    {label}
                  </Text>
                  {inputValue ? (
                    <Text
                      variant="action1"
                      className={csx({ display: 'block' })}
                    >
                      {inputValue}
                    </Text>
                  ) : (
                    <EmptyValue />
                  )}
                </div>
              )
            })}
          </div>
        )
      })}
      <Button
        type="button"
        size="large"
        onClick={onSubmit}
        className={csx({
          width: '100%',
          marginTop: '$space-4',
        })}
      >
        <FormattedMessage id="addToCartFooterLabel" />
      </Button>
    </div>
  )
}

const EmptyValue = () => {
  return (
    <Text
      variant="action1"
      className={csx({ color: '$disabled', lineHeight: 2 })}
    >
      (<FormattedMessage id="attachments.modal.summary.empty-value" />)
    </Text>
  )
}
